/**
 * Generates a data activity map ID based on the provided parameters.
 *
 * @param {object} args
 * @param {string} args.pageRegion
 * @param {string} args.componentName
 * @param {string} args.componentTitle
 */
export const getDataActivityMapID = ({ pageRegion = 'not-set', componentName, componentTitle }) => {
  const sanitizedComponentTitle = componentTitle
    ? componentTitle.toLowerCase().replace(/ /g, '-')
    : '';
  return sanitizedComponentTitle
    ? `${componentName}-${pageRegion}-${sanitizedComponentTitle}`
    : `${componentName}-${pageRegion}`;
};
